import { makeStyles } from "tss-react/mui";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

const useStyles = makeStyles()((theme) => ({
  skeletonBox: {
    padding: "30px",
    borderRadius: "14px",
    backgroundColor: "white",
    boxShadow: "0px 1.83px 5.48px 0px #0D0A2C14",
    width: "100%",
    boxSizing: "border-box",
    //
    height: "100%",
    minHeight: "460px",
    [theme.breakpoints.down("sm")]: {
      height: "460px",
    },
  },
  rootItem: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    height: "100%",
    minHeight: "460px",
    [theme.breakpoints.down("sm")]: {
      height: "460px",
    },
  },
  flex: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    backround: "none",
  },
  parent: {
    overflow: "hidden",
  },
  headerText: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "20px",
    color: "#272525",
  },
  pageText: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "10%",
    marginBottom: "10px",
  },
  pagesContainer: {
    height: "100%",
    padding: "30px",
    borderRadius: "14px",
    background: "white",
  },
  profile: {
    alignItems: "center",
    backgroundColor: theme.palette.primary.light,
    marginRight: 10,
    fontSize: "12px",
    fontWeight: 500,
  },
  //
  name: {
    fontWeight: 400,
    fontSize: "12px",
    fontFamily: "Poppins",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  tooltip: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    fontStyle: "normal",
    color: "#fff",
    lineWidth: "20px",
    background: "black",
  },
  avatarAndText: {
    display: "flex",
    alignItems: "center",
  },
  figure: {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    color: "#272525",
    paddingTop: 5,
  },
}));

export default useStyles;

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    fontStyle: "normal",
    color: "#fff",
    lineWidth: "20px",
    background: "black",
  },
});
export { StyledTooltip };
